export default 'Navigation Mode';